import * as z from "zod/v4";

const LinearLabelSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
});

export const LinearLabelSchema: z.ZodType<LinearLabel> = LinearLabelSchema_;
export interface LinearLabel extends z.infer<typeof LinearLabelSchema_> {}

export const getLinearTeamLabels = {
  name: "getLinearTeamLabels" as const,
  input: z.object({}),
  output: z.object({ labels: z.array(LinearLabelSchema) }),
};
